import React, { useState } from "react";
import { Modal, Box, Tabs, Tab, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useAuth from "../../hooks/useAuth";
import ModalTab from "./ModalTab";
import AdminTransferTab from "./AdminTransferTab";

const ModalWithTabs = ({
  isOpen,
  onClose,
  setWalletModal,
  setAccountModal,
  userId,
}) => {
  const [currentTab, setCurrentTab] = useState(0);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const axiosPrivate = useAxiosPrivate();
  const { queryUserDetails, setQueryUserDetails } = useAuth();
  const [txLoading, setTxLoading] = useState(false);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleWalletClick = async (event) => {
    setWalletModal({ open: true });
  };
  const handleAccountClick = (event) => {
    setAccountModal({ open: true });
  };
  const handleCardClick = (event) => {
    console.log("Card clicked");
  };

  const handleTxPageChange = async (newPage) => {
    if (!userId) return;
    setTxLoading(true);
    try {
      const response = await axiosPrivate.get(
        "/transaction-payment/api/v1/admin/transactions/user/" + userId,
        {
          params: {
            page: newPage,
            size: 5,
          },
        }
      );
      setQueryUserDetails((prev) => {
        return {
          ...prev,
          manageTransaction: response?.data?.data,
        };
      });
    } catch (error) {
      console.error("Error fetching transactions page:", error);
    } finally {
      setTxLoading(false);
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          width: 800,
          backgroundColor: colors.primary[400],
          p: 3,
          position: "relative",
          top: "50%",
          left: "55%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          textColor="secondary"
          indicatorColor="secondary"
          centered
        >
          <Tab label="ACCOUNTS" />
          <Tab label="TRANSACTIONS" />
          <Tab label="TRANSFERS" />
        </Tabs>
        <Box
          sx={{
            p: 2,
            maxHeight: "70vh",
            overflowY: "auto",
          }}
        >
          {currentTab === 0 && (
            <ModalTab handleClick={handleWalletClick} title="Accounts" />
          )}
          {currentTab === 1 && (
            <ModalTab
              handleClick={handleCardClick}
              title="Transactions"
              onPageChange={handleTxPageChange}
              loading={txLoading}
            />
          )}
          {currentTab === 2 && (
            <AdminTransferTab
              userId={userId}
              accounts={queryUserDetails?.manageAccount?.accounts || []}
            />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalWithTabs;
